import Axios from 'axios';

const RESOURCE = '/api/reports';

export default {
  /**
  * Retrieve job overview report
  */
  getJobStats() {
    return Axios.get(`${RESOURCE}/jobs/stats`);
  },

  /**
  * Find all pending jobs
  */
  getPendingJobs() {
    return Axios.get(`${RESOURCE}/jobs/pending`);
  },

  /**
  * Find all failed jobs
  */
  getFailedJobs() {
    return Axios.get(`${RESOURCE}/jobs/failed`);
  },
  /**
  * Find recently finished jobs
  */
  getCompleteJobs() {
    return Axios.get(`${RESOURCE}/jobs/complete`);
  },

  /**
  * Get all new users
  */
  getNewUsers() {
    return Axios.get(`${RESOURCE}/users/new`);
  },

  /**
  * Get paused users report
  */
  getPausedUsers() {
    return Axios.get(`${RESOURCE}/users/paused`);
  },

  /**
  * Get canceled users report
  */
  getCanceledUsers() {
    return Axios.get(`${RESOURCE}/users/canceled`);
  },

  /**
  * Get reactivating users
  */
  getReactivations() {
    return Axios.get(`${RESOURCE}/users/reactivations`);
  },

  /**
  * Get metrics overview
  */
  getMetrics() {
    return Axios.get(`${RESOURCE}/metrics`);
  }

}
